/** Remember the builder URL so Integrations can send the user back after they connect. */

const KEY = "ebBuilderReturn";

export const rememberBuilderReturn = () => {
  try {
    sessionStorage.setItem(KEY, `${window.location.pathname}${window.location.search}`);
  } catch (e) {
    /* private mode */
  }
};

export const readBuilderReturn = () => {
  try {
    const value = sessionStorage.getItem(KEY) || "";
    return value.startsWith("/admin/events/builder") ? value : "";
  } catch (e) {
    return "";
  }
};

export const clearBuilderReturn = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch (e) {
    /* ignore */
  }
};
